export const getFeatureTableV3QueryParamNamespace = (queryStateNamespace?: string): string =>
  queryStateNamespace ? `${queryStateNamespace}-feature-v3` : "feature-v3";
